module.exports = __webpack_public_path__ + "files/880d8b328613e3a416d176e429f4024f.png";